<idp-switching-profile
  [content]="
    (facade.switchingProfileDetails$ | ngrxPush) || emptySwitchProfileDetails
  "
  [flyoutToggle]="flyoutToggle"
  (flyoutToggleChange)="flyoutToggleChange.emit($event)"
  (analyticsEvent)="handleAnalytics($event)"
></idp-switching-profile>
